import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import * as Sentry from '@sentry/react';

import { parentUser } from '../../../lib/services/auth.service';
import { APP_TITLE } from '../../../../_configuration';
import { parentLoginPathWithNext } from '../../../lib/helpers/parent-links.helpers';
import ErrorPage from '../../_pages/_boilerplate/ErrorPage/error-page.container';

interface ITokenOrParentRouteProps {
  component: any;
  title?: string;
  exact?: boolean;
  path: string;
}

// Gate for the token-OR-parent routes (public player, report card): allow a
// `?token=` URL param OR a parent JWT, else redirect to the parent login.
export const TokenOrParentRoute: React.FC<ITokenOrParentRouteProps> = ({ component: Component, title, ...rest }) => {
  const parent = useReactiveVar(parentUser);

  return (
    <Route
      {...rest}
      render={(props) => {
        const hasToken = !!new URLSearchParams(props.location.search).get('token');
        if (!hasToken && !parent) return <Redirect to={parentLoginPathWithNext(props.location.pathname, props.location.search)} />;
        document.title = title || APP_TITLE;
        return (
          <Sentry.ErrorBoundary fallback={ErrorPage}>
            <Component {...props} />
          </Sentry.ErrorBoundary>
        );
      }}
    />
  );
};
